import { useSelector } from "react-redux";

export const useCurrentuser = () => {
  return useSelector((state) => state.Auth.currentUser);
};
